import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { useInternalDynamicContext } from '../../../../context/DynamicContext/useInternalDynamicContext.js';
import { useWidgetContext } from '../../context/DynamicWidgetContext.js';
import { DetectedKnownSecondaryWalletModal } from '../../prompts/DetectedKnownSecondaryWalletModal/DetectedKnownSecondaryWalletModal.js';
import { DetectedNewWalletModal } from '../../prompts/DetectedNewWalletModal/DetectedNewWalletModal.js';
import { PendingAccountSwitchModal } from '../../prompts/PendingAccountSwitchModal/PendingAccountSwitchModal.js';
import { PendingSignModal } from '../../prompts/PendingSignModal/PendingSignModal.js';
import { PrimaryNotConnectedModal } from '../../prompts/PrimaryNotConnectedModal/PrimaryNotConnectedModal.js';
import { QrCodeModalView } from '../../prompts/QrCodeModalView/QrCodeModalView.js';
import { UnlinkWalletPopUp } from '../../prompts/UnlinkWalletPopUp/UnlinkWalletPopUp.js';
import { WidgetPortal } from '../WidgetPortal/WidgetPortal.js';

const mapAccountSwitchStateToPromptComponent = {
    linking_new_wallet: PendingAccountSwitchModal,
    primary_not_connected: PrimaryNotConnectedModal,
    switching_primary: PendingAccountSwitchModal,
};
const DynamicWidgetPrompts = () => {
    const { setDesktopUri, accountSwitchState, multiWalletWidgetState, showQrcodeModal, setShowQrcodeModal, } = useInternalDynamicContext();
    const { walletIdToUnlink, newWalletId, setNewWalletId } = useWidgetContext();
    const AccountSwitchModal = useMemo(() => {
        if (multiWalletWidgetState !== 'awaiting_account_switch')
            return null;
        return mapAccountSwitchStateToPromptComponent[accountSwitchState] || null;
    }, [accountSwitchState, multiWalletWidgetState]);
    return (jsxs(Fragment, { children: [multiWalletWidgetState === 'awaiting_signature' && jsx(PendingSignModal, {}), AccountSwitchModal && jsx(AccountSwitchModal, {}), walletIdToUnlink && jsx(UnlinkWalletPopUp, { walletId: walletIdToUnlink }), multiWalletWidgetState === 'awaiting_connection' &&
                (showQrcodeModal ? (jsx(WidgetPortal, Object.assign({ onBackdropClick: () => {
                        setShowQrcodeModal(false);
                        setDesktopUri('');
                    } }, { children: jsx(QrCodeModalView, { walletId: newWalletId }) }))) : (jsx(PendingSignModal, {}))), multiWalletWidgetState === 'detected_known_secondary_wallet' && (jsx(DetectedKnownSecondaryWalletModal, { setNewWalletId: setNewWalletId })), multiWalletWidgetState === 'detected_new_wallet' && (jsx(DetectedNewWalletModal, {}))] }));
};

export { DynamicWidgetPrompts };
